import { useGetSingePageSourceRule } from '@op/hooks/useGetPageSourceRule';
import { useMemo } from 'react';

export default function useSentimentValue({
  updateSentiment,
  sentiment,
}: {
  updateSentiment?: string;
  sentiment: string;
}) {
  const { Sentiment_Update } = useGetSingePageSourceRule({
    keys: 'Sentiment_Update',
  });

  const realSentiment = useMemo(() => {
    if (updateSentiment) return updateSentiment;

    if (Sentiment_Update) return 0;

    return sentiment;
  }, [sentiment, updateSentiment]);

  return { realSentiment, Sentiment_Update };
}
